module.exports = __webpack_public_path__ + "static/img/more-text-1.d341a5ba.png";